<!-- Sem Lançamento -->
<sgt-cliente-analise-mercado-status-projetado-badge-pill-nao-projetado
    *ngIf="isNaoProjetado()"
    [title]="title">
</sgt-cliente-analise-mercado-status-projetado-badge-pill-nao-projetado>
<!-- Projetado -->
<sgt-cliente-analise-mercado-status-projetado-badge-pill-projetado
    *ngIf="isProjetado()"
    [title]="title">
</sgt-cliente-analise-mercado-status-projetado-badge-pill-projetado>
<!-- Em Negociação -->
<sgt-cliente-analise-mercado-status-projetado-badge-pill-em-negociacao
    *ngIf="isEmNegociacao()"
    [idEtapaNegociacaoProjecao]="idEtapaNegociacaoProjecao"
    [nomeEtapaNegociacaoProjecao]="nomeEtapaNegociacaoProjecao"
    [title]="title">
</sgt-cliente-analise-mercado-status-projetado-badge-pill-em-negociacao>
<!-- Ganho -->
<sgt-cliente-analise-mercado-status-projetado-badge-pill-ganho
    *ngIf="isGanho()"
    [title]="title">
</sgt-cliente-analise-mercado-status-projetado-badge-pill-ganho>
<!-- Perdido -->
<sgt-cliente-analise-mercado-status-projetado-badge-pill-perdido
    *ngIf="isPerdido()"
    [title]="title">
</sgt-cliente-analise-mercado-status-projetado-badge-pill-perdido>